<style scoped lang="scss">
    @import "../../styles/var";
    @import "../../styles/mixins";

    .ava img {
        @include w_h(50px);
    }

    .item.row {
        .ava {
            margin-right: 10px;
        }

        .icon {
            @include w_h(0px);
            top: 30px;
            left: -10px;
            border-top: 5px solid transparent;
            border-bottom: 5px solid transparent;
            border-right: 10px solid #ffffff;
        }

        .msgbox {
            border-radius: 4px;
            color: #333333;
            background-color: #F3F3F3;
        }
    }

    .item.reverse {
        flex-direction: row-reverse;

        .ava {
            margin-left: 10px;
        }

        .icon {
            @include w_h(0px);
            top: 30px;
            right: -10px;
            border-top: 5px solid transparent;
            border-bottom: 5px solid transparent;
            border-left: 10px solid $mainColor;
        }

        p {
            text-align: right;
        }

        .msgbox {
            border-radius: 4px;
            color: #333333;
            background-color:  #E6F1FC;
        }
    }
</style>
<template>
    <div class="item flex" :class="[dir]">
        <div class="ava flex0">
            <img :src="userDocVo.docAvatar||docDefaultAva" class="radius50" alt="">
        </div>
        <div class="msg flex1 relative">
            <p class="fs12 color_666">{{userDocVo.docName}}</p>
            <div class="msgbox mt5 pt10 pb10 pl10 pr10 fs14">{{consultMessage.replyContent}}</div>
            <div class="icon absolute"></div>
        </div>
        <div class="pl15 pr15 flex0" :class="['width'+blank]">&nbsp;</div>
    </div>
</template>

<script>
  import {isEmpty} from "../../lib/utils";

  export default {
    name: "message-box-item",
    components: {},
    props: {
      blank: {
        type: String,
        default: '0'
      },
      info: Object
    },
    computed: {
      consultMessage() {
        return this.info.consultMessage || {};
      },
      userDocVo() {
        return this.info.userDocVo || {};
      },
      dir() {
        const {doc} = this.loginInfo;
        const {consultMessage} = this;
        if (isEmpty(consultMessage)) return ['row', 'reverse'][Math.floor(Math.random() * 2)];
        else {
          return doc.id === consultMessage.replierId ? 'reverse' : 'row';
        }
      }
    },
  }
</script>
